import { classNames } from "@NBCUDTC/reactjs-utility-belt/classnames";
import { Icon } from "@NBCUDTC/reactjs-utility-belt/components/atoms/Icon";

import { StreamingIcons } from "@/assets/iconFont/streaming-icons";

import type { MobileTopNavItemProps } from "./types";
import styles from "./MobileTopNavItem.module.scss";

/**
 * Mobile Top Nav Item that renders a single navigation item with optional dropdown
 *
 * @param label - The text label for the navigation item
 * @param dropdown - If the item has a dropdown menu
 * @param onClick - Click event handler for the item
 * @param className - Additional class names for styling
 * @param attrs - Additional HTML attributes for the button element
 * @returns the MobileTopNavItem component
 *
 * @example
 * ```tsx
 * <MobileTopNavItem label="Home" dropdown={true} onClick={() => console.log('Clicked!')} />
 * ```
 */
const MobileTopNavItem = ({
  label,
  dropdown = false,
  onClick,
  className,
  ...attrs
}: MobileTopNavItemProps) => {
  const cn = classNames(
    styles["nav-item"],
    dropdown && styles["dropdown"],
    className,
  );

  return (
    <button className={cn} onClick={onClick} {...attrs}>
      {label}
      {dropdown && (
        <Icon icon={StreamingIcons.ChevronDown} className={styles["chevron"]} />
      )}
    </button>
  );
};

export { MobileTopNavItem };
